import { URLParamFilter } from "src/base-components/tableColumnFilters/useFilters";
import {
  tracker,
  trackingEvents,
} from "src/instrumentation/customTrackingEvents";
import { useWorkspaceContext } from "src/router/routerContextHooks";

export const useTrackEntityFunnel = (entitySchemaType: string) => {
  const { orgId } = useWorkspaceContext();
  const baseProps = {
    organization_id: orgId,
    entity_schema_type: entitySchemaType,
  };

  const trackSearchExecuted = () => {
    tracker.emit(trackingEvents.entitySearchExecuted(baseProps));
  };

  const trackFilterApplied = (appliedFilters: URLParamFilter[]) => {
    tracker.emit(
      trackingEvents.entityFilterApplied({
        ...baseProps,
        // filter values may contain PII, only track key + operator
        filters: appliedFilters.map(({ key, operator }) => ({ key, operator })),
      }),
    );
  };

  const trackDetailOpened = (entityId: string) => {
    tracker.emit(
      trackingEvents.entityDetailOpened({
        ...baseProps,
        entity_id: entityId,
      }),
    );
  };

  const trackCreateCaseClicked = (entityId: string) => {
    tracker.emit(
      trackingEvents.entityCreateCaseClicked({
        ...baseProps,
        entity_id: entityId,
      }),
    );
  };

  const trackRelatedCaseDetailOpened = (entityId: string, caseId: string) => {
    tracker.emit(
      trackingEvents.entityRelatedCaseDetailOpened({
        ...baseProps,
        entity_id: entityId,
        case_id: caseId,
      }),
    );
  };

  const trackRelatedCaseOpened = (entityId: string, caseId: string) => {
    tracker.emit(
      trackingEvents.entityRelatedCaseOpened({
        ...baseProps,
        entity_id: entityId,
        case_id: caseId,
      }),
    );
  };

  return {
    trackSearchExecuted,
    trackFilterApplied,
    trackDetailOpened,
    trackCreateCaseClicked,
    trackRelatedCaseDetailOpened,
    trackRelatedCaseOpened,
  };
};
